import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Applogo } from "../Routes/ImagePath";
import "./rolesPage.css";

function RolesPage() {
  // name: display label shown on the card
  // backendRoles: all role strings the backend may return for this card (case-insensitive match)
  const roleData = [
    { id: 1, name: "Sales", backendRoles: ["sales"], image: require("../assets/img/icons/Sales.png") },
    { id: 2, name: "Credit", backendRoles: ["credit"], image: require("../assets/img/icons/Credit.png") },
    {
      id: 3,
      name: "Operation",
      backendRoles: ["operation", "operations"],
      image: require("../assets/img/icons/Operation.png"),
    },
    { id: 4, name: "Legal", backendRoles: ["legal"], image: require("../assets/img/icons/Legal.png") },
    {
      id: 5,
      name: "Technical",
      backendRoles: ["technical"],
      image: require("../assets/img/icons/Technical.png"),
    },
    { id: 6, name: "FCU", backendRoles: ["fcu"], image: require("../assets/img/icons/FDU.png") },
    {
      id: 7,
      name: "Collection",
      backendRoles: ["collection"],
      image: require("../assets/img/icons/Collection.png"),
    },
    {
      id: 8,
      name: "CCU",
      backendRoles: ["ccu"],
      image: require("../assets/img/icons/CCU.png"),
    },
    {
      id: 9,
      name: "IT",
      backendRoles: ["it", "technology"],
      image: require("../assets/img/icons/IT.png"),
    },
    {
      id: 10,
      name: "HR",
      backendRoles: ["hr"],
      image: require("../assets/img/icons/HR.png"),
    }
  ];

  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const user = sessionStorage.getItem("user");
    const userData = JSON.parse(user);
    setRoles(userData.roles);
  }, []);

  const handleRoleClick = (roleCard) => {
    // Find the backend role string that matches this card's known aliases
    const matchedRole = roles.find((r) =>
      roleCard.backendRoles.includes(r.toLowerCase())
    );
    if (matchedRole) {
      // Store the card's canonical name (not the raw backend string) so the
      // Sidebar's strict equality checks (roleName === "IT", etc.) always match.
      sessionStorage.setItem("role", JSON.stringify(roleCard.name));
      // HR role goes directly to Employee Grievances (no dashboard)
      if (roleCard.name.toLowerCase() === "hr") {
        navigate("/employee-grievances");
      } else {
        navigate("/employee-dashboard");
      }
    } else {
      alert("You do not have access to this role.");
    }
  };

  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            <div className="container">
              <div className="account-logo">
                <Link to="/admin-dashboard">
                  <img src={Applogo} alt="Roha housing" style={{height: "8vh", width: "25vw"}} />
                </Link>
              </div>
              <div className="account-box">
                <div className="account-wrapper">
                  <div className="row">
                    {roleData
                      .filter((role) =>
                        roles.some((r) =>
                          role.backendRoles.includes(r.toLowerCase())
                        )
                      )
                      .map((role) => (
                        <div key={role.id} className="col-4 col-md-3">
                          <div
                            className="card"
                            style={{ "--bs-card-spacer-x": "0.9rem" }}
                            onClick={() => handleRoleClick(role)}
                          >
                            <div className="card-header p-0 text-center">
                              <img
                                src={role.image}
                                alt={role.name}
                                className="img-fluid"
                              />
                            </div>
                            <div className="card-body text-center p-0">
                              <p className="card-title mb-0 fs-6">
                                {role.name}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                  <div className="account-footer"></div>
                  <div>
                    <div className="account-footer"></div>
                  </div>
                  {/* /Account Form */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    //         <div>
    //             <div className="account-page">
    //                 <div className="container">
    //                     <div className="account-content">
    //                         <div className="row d-flex justify-content-center">
    //                             <div className="col-md-12">
    //                                 <div className="text-center mt-4" style={{ marginBottom: "30px" }}>
    //                                     <Link to="/admin-dashboard">
    //                                         <img src={Applogo} alt="Roha housing" />
    //                                     </Link>
    //                                 </div>
    //                                 <div className="account-box">
    //     <div className="account-wrapper">
    //         <div className="row">
    //             {roleData.map((role) => (
    //                 <div key={role.id} className="col-md-3">
    //                     <div className="card"
    //                         style={{ '--bs-card-spacer-x': '0.9rem' }}
    //                         onClick={() => handleRoleClick(role.name)}
    //                     >
    //                         <div className="card-header text-center">
    //                             <img src={role.image} alt={role.name} className="img-fluid" />
    //                         </div>
    //                         <p style={{ textAlign: 'center' }}>
    //                             {roles.includes(role.name) ? role.name : 'No Access'}
    //                         </p>
    //                     </div>
    //                 </div>
    //             ))}
    //         </div>
    //         <div className="account-footer"></div>
    //     </div>
    // </div>

    //                             </div>
    //                             <div className="col-md-4">
    //                                 {/* <Sidebar roles={roleData} /> */}
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
  );
}

export default RolesPage;
